import React, { useEffect, useState, useRef } from 'react';

// Escolha do vendedor ao finalizar a venda (Parâmetros → PDV → "Solicitar
// vendedor"). Lista apenas usuários ativos com "Exibir no PDV" marcado.
// ↑/↓ navegam, Enter confirma, Esc volta ao pagamento.
export default function ModalVendedor({ vendedores, vendedorPadraoId, onConfirmar, onFechar }) {
  const [idx, setIdx] = useState(() => {
    const i = vendedores.findIndex(v => v.id === vendedorPadraoId);
    return i >= 0 ? i : 0;
  });
  const listRef = useRef(null);

  useEffect(() => {
    const h = e => {
      e.stopPropagation();
      if (e.key === 'Escape') { e.preventDefault(); onFechar(); }
      if (e.key === 'ArrowDown') { e.preventDefault(); setIdx(i => Math.min(i + 1, vendedores.length - 1)); }
      if (e.key === 'ArrowUp')   { e.preventDefault(); setIdx(i => Math.max(i - 1, 0)); }
      if (e.key === 'Enter' && vendedores[idx]) { e.preventDefault(); onConfirmar(vendedores[idx].id); }
    };
    document.addEventListener('keydown', h, true);
    return () => document.removeEventListener('keydown', h, true);
  }, [idx, vendedores, onConfirmar, onFechar]);

  useEffect(() => {
    listRef.current?.children[idx]?.scrollIntoView?.({ block: 'nearest' });
  }, [idx]);

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(15,23,42,.55)', zIndex: 10000,
      display: 'flex', alignItems: 'center', justifyContent: 'center' }}
      onMouseDown={e => { if (e.target === e.currentTarget) onFechar(); }}>
      <div style={{ background: '#fff', borderRadius: 6, width: 380, maxWidth: '92vw',
        boxShadow: '0 10px 40px rgba(0,0,0,.4)', overflow: 'hidden' }}>
        <div style={{ background: '#0f2557', color: '#fff', padding: '10px 14px',
          fontSize: 13, fontWeight: 700 }}>
          🧑‍💼 Vendedor da venda
        </div>
        <div ref={listRef} style={{ maxHeight: 300, overflowY: 'auto', padding: 6 }}>
          {vendedores.length === 0 && (
            <div style={{ padding: 16, fontSize: 12, color: '#92400e', background: '#fffbeb',
              border: '1px solid #f59e0b', borderRadius: 4, margin: 6 }}>
              Nenhum usuário marcado com <strong>"Exibir no PDV"</strong>.<br />
              Marque em Administrativo → Usuários. A venda pode seguir com o operador atual.
            </div>
          )}
          {vendedores.map((v, i) => (
            <div key={v.id}
              onClick={() => onConfirmar(v.id)}
              onMouseEnter={() => setIdx(i)}
              style={{ padding: '9px 12px', borderRadius: 4, cursor: 'pointer', fontSize: 13,
                display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                background: i === idx ? '#1565c0' : 'transparent',
                color: i === idx ? '#fff' : '#111827', fontWeight: i === idx ? 600 : 400 }}>
              <span>{v.nome}</span>
              {v.id === vendedorPadraoId && (
                <span style={{ fontSize: 10, opacity: .8 }}>(operador)</span>
              )}
            </div>
          ))}
        </div>
        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end',
          padding: '10px 14px', borderTop: '1px solid #e5e7eb' }}>
          <button onClick={onFechar}
            style={{ height: 30, padding: '0 14px', border: '1px solid #cbd5e1', borderRadius: 4,
              background: '#f8fafc', fontSize: 13, cursor: 'pointer' }}>
            Cancelar (Esc)
          </button>
          {vendedores.length === 0 ? (
            <button onClick={() => onConfirmar(null)}
              style={{ height: 30, padding: '0 14px', border: '1px solid #0f2557', borderRadius: 4,
                background: '#1565c0', color: '#fff', fontSize: 13, fontWeight: 600, cursor: 'pointer' }}>
              Continuar com o operador
            </button>
          ) : (
            <button onClick={() => vendedores[idx] && onConfirmar(vendedores[idx].id)}
              style={{ height: 30, padding: '0 14px', border: '1px solid #0f2557', borderRadius: 4,
                background: '#1565c0', color: '#fff', fontSize: 13, fontWeight: 600, cursor: 'pointer' }}>
              Confirmar (Enter)
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
